import React from "react";
import styled, { css } from "styled-components";

interface IStyledContainerProps {
    narrow?: boolean;
    mid?: boolean;
}

const StyledContainer = styled.div<IStyledContainerProps>`
    padding: 0 $space-60 $space-20 $space-60;

    ${props =>
        props.narrow &&
        css`
            width: 100%;
            max-width: 50rem;
            margin-left: auto;
            margin-right: auto;
        `}

    ${props =>
        props.mid &&
        css`
            width: 100%;
            max-width: 70rem;
            margin-left: auto;
            margin-right: auto;
        `}

    /* Apply the additional className if provided */
    ${props => props.className}

    @media (max-width: 48rem) {
        padding-left: $space-20;
        padding-right: $space-20;
    }
`;

export interface IContainerProps {
    narrow?: boolean;
    mid?: boolean;
    className?: string;
    children?: React.ReactNode;
}

export function Container(props: IContainerProps) {
    const { children } = props;

    return <StyledContainer {...props}>{children}</StyledContainer>;
}
